import React from "react"
import { useParams } from "react-router-dom"
import APMPAllInfo from "../apmpComponents/ApmpAllInfo"
import APPAllInfo from "../appComponents/AppAllInfo"
import ARMPAllInfo from "../armpComponents/ArmpAllInfo"
import ASLAllInfo from "../aslComponents/AslAllInfo"
import BsfAllInfo from "../bsfComponents/BsfAllInfo"
import CDBAllInfo from "../cdbComponents/CdbAllInfo"
import CmnAllInfo from "../cmnComponents/CmnAllInfo"
import ComIRMAllInfo from "./ComIRMAllInfo"
import ComPageAllInfo from "./ComPageAllInfo"
import CopAllInfo from "../copComponents/CopAllInfo"
import CopyListAllInfo from "../copListComponents/CopyListAllInfo"
import CupAllInfo from "../cupComponents/CupAllInfo"
import DPPAllInfo from "../dppComponents/DppAllInfo"
import EmpAllInfo from "../empComponents/EmpAllInfo"
import FABAllInfo from "../fabComponents/FabAllInfo"
import FcAllInfo from "../fcComponents/FcAllInfo"
import FopAllInfo from "../fopComponents/FopAllInfo"
import FppAllInfo from "../fppComponents/FppAllInfo"
import IMPAllInfo from "../impComponents/ImpAllInfo"
import IpAllInfo from "../ipComponents/IpAllInfo"
import IPPAllInfo from "../ippComponents/IppAllInfo"
import IRMSAllInfo from "../irmsComponents/IrmsAllInfo"
import MCOPAllInfo from "../mcopComponents/McopAllInfo"
import MCPAllInfo from "../mcpComponents/McpAllInfo"
import MCUPAllInfo from "../mcupComponents/McupAllInfo"
import MEPAllInfo from "../mepComponents/MepAllInfo"
import MIPAllInfo from "../mipComponents/MipAllInfo"
import MPAPAllInfo from "../mpapComponents/MpapAllInfo"
import MPMPAllInfo from "../mpmpComponents/MpmpAllInfo"
import MPPAllInfo from "../mppComponents/MppAllInfo"
import MpsAllInfo from "../mpsComponents/MpsAllInfo"
import MRMPAllInfo from "../mrmpComponents/MrmpAllInfo"
import OPPAllInfo from "../oppComponents/OppAllInfo"
import PAPAllInfo from "../papComponents/PapAllInfo"
import PIPAllInfo from "../pipComponents/PipAllInfo"
import PmpAllInfo from "../pmpComponents/PmpAllInfo"
import POAAllInfo from "../poaComponents/PoaAllInfo"
import PQRInfo from "../pqrComponents/PqrAllInfo"
import PsubAllInfo from "../psubComponents/PsubAllInfo"
import RmpAllInfo from "../rmpComponents/RmpAllInfo"
import SbvAllInfo from "../sbvComponents/SbvAllInfo"
import SEPAllInfo from "../sepComponents/SepAllInfo"
import SisAllInfo from "../sisComponents/SisAllInfo"
import SmlAllInfo from "../smlComponents/SmlAllInfo"
import SwpAllInfo from "../swpComponents/SwpAllInfo"
import TupAllInfo from "../tupComponents/TupAllInfo"
import PageNotFound from "../PageNotFound"

const TYPE_COMPONENT_MAP = {
   APMP: APMPAllInfo,
   APP: APPAllInfo,
   ARMP: ARMPAllInfo,
   ASL: ASLAllInfo,
   BSF: BsfAllInfo,
   CDB: CDBAllInfo,
   CMA: CmnAllInfo,
   CMN: CmnAllInfo,
   COM: ComPageAllInfo,
   CL: CopyListAllInfo,
   COP: CopAllInfo,
   CUP: CupAllInfo,
   DPP: DPPAllInfo,
   EMP: EmpAllInfo,
   FAB: FABAllInfo,
   FC: FcAllInfo,
   FOP: FopAllInfo,
   FPP: FppAllInfo,
   IMP: IMPAllInfo,
   IP: IpAllInfo,
   IPP: IPPAllInfo,
   IRMS: IRMSAllInfo,
   MCOP: MCOPAllInfo,
   MCP: MCPAllInfo,
   MCUP: MCUPAllInfo,
   MEP: MEPAllInfo,
   MIP: MIPAllInfo,
   MPAP: MPAPAllInfo,
   MPMP: MPMPAllInfo,
   MPP: MPPAllInfo,
   MPS: MpsAllInfo,
   MRMP: MRMPAllInfo,
   OPP: OPPAllInfo,
   PAP: PAPAllInfo,
   PIP: PIPAllInfo,
   PMP: PmpAllInfo,
   POA: POAAllInfo,
   PQR: PQRInfo,
   PSUB: PsubAllInfo,
   RMP: RmpAllInfo,
   SBV: SbvAllInfo,
   SEP: SEPAllInfo,
   SIS: SisAllInfo,
   SML: SmlAllInfo,
   SWP: SwpAllInfo,
   TUP: TupAllInfo,
}

function PreliminaryRouter() {
   const { type, subType } = useParams()
   // COM route (/preliminary/COM/:subType/...) has no :type param — subType is set instead
   const Component = subType
      ? (subType.toUpperCase() === "IRM" ? ComIRMAllInfo : ComPageAllInfo)
      : type ? TYPE_COMPONENT_MAP[type.toUpperCase()] : null

   if (!Component) {
      return <PageNotFound />
   }

   return <Component />
}

export default PreliminaryRouter
